import Text from '@/components/Text';
import { isDataSourceScopedDataStream } from '@squaredup/data-streams';
import { FormToggleTable } from 'components/toggle-table/FormToggleTable';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import type { DataStream } from 'services/DataStreamDefinitionService';
import type { PluginSaveFormData } from './SaveAsPluginModalContent';

export const DataStreamsTab: React.FC<{ dataStreams: DataStream[]; basePluginId: string }> = ({
    dataStreams,
    basePluginId
}) => {
    const { error } = useFormContext<PluginSaveFormData>().getFieldState('dataStreams');

    return (
        <div className='flex flex-col gap-6 p-6'>
            <p>Select which data streams to include</p>

            <div className='flex items-center justify-between'>
                <Text.H3>Saved Data Streams</Text.H3>
                {error && <span className='text-statusErrorPrimary'>{error.message || 'This value is invalid.'}</span>}
            </div>
            {
                <FormToggleTable
                    items={dataStreams.filter((ds) => ds.parentPluginId !== basePluginId)}
                    getName={(stream) => `dataStreams.${stream.id}`}
                    getLabel={(stream) => stream.displayName}
                />
            }
            <Text.H3>Other Data Streams</Text.H3>
            <Text.Body>Only data streams that have data source node scopes can be included.</Text.Body>
            {
                <FormToggleTable
                    items={dataStreams.filter(
                        (ds) =>
                            ds.parentPluginId === basePluginId &&
                            isDataSourceScopedDataStream(ds.pluginId, ds.definition.matches ?? {})
                    )}
                    getName={(stream) => `dataStreams.${stream.id}`}
                    getLabel={(stream) => stream.displayName}
                />
            }
        </div>
    );
};
